import { render } from "./SimpleKeyboard.vue?vue&type=template&id=1b8010cc&scoped=true"
import script from "./SimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=1b8010cc&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8010cc"]])

export default __exports__